// routes
import { path_dashboard } from 'src/routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { AuthUser } from 'src/@type/auth';
import { NavListProps } from 'src/components/nav-section/type';

// ----------------------------------------------------------------------
const getIcon = (name: string) => (
    <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
    user: getIcon('ic_user'),
    broker_hub_monitor: getIcon('ic_broker_hub_process_monitor'),
    broker_hub_status: getIcon('ic_broker_hub_process_status'),
    broker_hub_import: getIcon('ic_file_management'),
    physical_markets: getIcon('ic_physical_markets'),
    api_trace: getIcon('ic_api_trace'),
    fusion_summary: getIcon('ic_fusion_summary'),
    global_position: getIcon('ic_global_position'),
    desk_position: getIcon('ic_desk_position'),
    focus_report: getIcon('ic_focus_report'),
    position_by_desk: getIcon('ic_position_by_desk'),
    position_by_product: getIcon('ic_position_by_product'),
    greeks_report: getIcon('ic_greeks_report'),
    dynamic_prototype_report: getIcon('ic_dynamic_prototype_report'),
    settings: getIcon('ic_settings'),
};

const navConfig = (user: AuthUser) => {
    let navConfig: { subheader: string, items: NavListProps[] }[] = [];

    if (user?.Applications?.some(e => e.ApplicationCode === 'API')) {
        let apiConfig: { subheader: string, items: NavListProps[] } = {
            subheader: 'Api', items: [
                {
                    title: 'API Trace',
                    path: path_dashboard.api.api_trace,
                    icon: ICONS.api_trace
                }, {
                    title: 'Fusion Summary',
                    path: path_dashboard.api.fusion_summary,
                    icon: ICONS.fusion_summary
                }
            ]
        };
        navConfig.push(apiConfig);
    }
    if (user?.Applications?.some(e => e.ApplicationCode === 'BROKER-HUB')) {
        let borkerHubConfig: { subheader: string, items: NavListProps[] } = {
            subheader: 'Broker Hub', items: [
                {
                    title: 'Process Monitor',
                    path: path_dashboard.broker_hub.process_monitor,
                    icon: ICONS.broker_hub_monitor
                },
                {
                    title: 'Process Status',
                    path: path_dashboard.broker_hub.process_status,
                    icon: ICONS.broker_hub_status
                }]
        };
        navConfig.push(borkerHubConfig);
    }
    if (user?.Applications?.some(e => e.ApplicationCode === 'PHYSICAL-MARKETS')) {
        let physicalMarketsConfig: { subheader: string, items: NavListProps[] } = {
            subheader: 'Physical Markets', items: [{
                title: 'Daily Pricing',
                path: path_dashboard.physical_markets.daily_pricing,
                icon: ICONS.physical_markets
            }]
        };
        navConfig.push(physicalMarketsConfig);
    }
    
    if (user?.Applications?.some(e => e.ApplicationCode === 'RISK-MANAGEMENT')) {
        let riskReportsConfig: { subheader: string, items: NavListProps[] } = {
            subheader: 'Risk Reports', items: [{
                title: 'Global Position',
                path: path_dashboard.risk_reports.global_position,
                icon: ICONS.global_position
            }, {
                title: 'Desk Position',
                path: path_dashboard.risk_reports.desk_position,
                icon: ICONS.desk_position
            }, {
                title: 'Focus Report',
                path: path_dashboard.risk_reports.focus_report,
                icon: ICONS.focus_report
            }, {
                title: 'Position By Desk',
                path: path_dashboard.risk_reports.position_by_desk,
                icon: ICONS.position_by_desk
            }, {
                title: 'Position By Product',
                path: path_dashboard.risk_reports.position_by_product,
                icon: ICONS.position_by_product
            }, {
                title: 'Greeks Report',
                path: path_dashboard.risk_reports.greeks_report,
                icon: ICONS.greeks_report
            }]
        };
        
        navConfig.push(riskReportsConfig);
    }
    if (user?.Applications?.some(e => e.ApplicationCode === 'RISK-MANAGEMENT' && e.Role === 'ADMIN')) {
        let riskManagementConfig: { subheader: string, items: NavListProps[] } = {
            subheader: 'Risk Management', items: [{
                title: 'Settings',
                path: path_dashboard.risk_management.settings.root,
                icon: ICONS.settings,
                children: [
                    { title: 'Desks', path: path_dashboard.risk_management.settings.desks },
                    { title: 'Portfolios', path: path_dashboard.risk_management.settings.portfolios },
                    { title: 'Limit Alerts', path: path_dashboard.risk_management.settings.limitAlerts },
                    { title: 'Reports', path: path_dashboard.risk_management.settings.reports }
                ]
            }]
        };

        navConfig.push(riskManagementConfig);
    }
    if (user?.Applications?.some(e => e.ApplicationCode === 'MANAGEMENT')) {
        let managementConfig: { subheader: string, items: NavListProps[] } = {
            subheader: 'Management', items: [
                {
                    title: 'Users',
                    path: path_dashboard.management.users,
                    icon: ICONS.user
                }
            ]
        };
        navConfig.push(managementConfig);
    }
    return navConfig;
}

export default navConfig;
